
import { storage } from "@/firebase";
import { ROOT_ACTIONS } from "@/store/actions";
import { ROOT_MUTATIONS } from "@/store/mutations";
import { USER_ACTIONS } from "@/store/user/actions";
import { USER_GETTERS } from "@/store/user/getters";
import { User } from "@/store/user/types";
import { getDownloadURL, ref } from "firebase/storage";
import { Component, Vue } from "vue-property-decorator";
import { getManualPath, ManualType } from "@/utils/manuals";

@Component({
  components: {
    ConfirmationDialog: () =>
      import("@/components/dialogs/ConfirmationDialog.vue"),
  },
})
export default class Navigation extends Vue {
  get sidebar(): boolean {
    return this.$store.state.navigation;
  }

  set sidebar(value: boolean) {
    this.$store.commit(ROOT_MUTATIONS.SET_NAVIGATION, value);
  }

  get authenticated(): boolean {
    return this.$store.state.user.authenticated;
  }

  get user(): User {
    return this.$store.getters[USER_GETTERS.ACTING_USER];
  }

  get userType(): string {
    return this.$store.getters[USER_GETTERS.USER_TYPE];
  }

  dialogs = {
    signOut: false,
  };

  loading = {
    signOut: false,
  };

  async signOut() {
    try {
      this.loading.signOut = true;
      await this.$store.dispatch(USER_ACTIONS.SIGNOUT);
      location.reload();
    } catch (error) {
      this.$store.dispatch(ROOT_ACTIONS.TOGGLE_NOTIFICATION, {
        color: "error",
        text: error,
      });
    } finally {
      this.loading.signOut = false;
      this.dialogs.signOut = false;
    }
  }

  async openManual(type: ManualType) {
    const url = await getDownloadURL(ref(storage, getManualPath(type, this.user.language)));
    window.open(url, '_blank');
  }
}
